<ng-container>
  <div class="banner" [class.rightRail]="rightRail">
    <div class="image-card">

      @if (rightRail) {
        @if (rightRail) {
          <img src="assets/images/advice-banner/Advice-right_rail.jpeg"
            alt="back of women with arms around each other image" />
        }
        <div class="banner-header">
          <h1 class="c11n-text-xl-headline" [innerHTML]="content.title"></h1>
        </div>
      } @else {
        <img class="standard" src="assets/images/advice-banner/Advice-full_width.jpeg"
          alt="back of women with arms around each other image" />
        <img class="mobile" src="assets/images/advice-banner/Advice-mobile.jpg"
          alt="back of women with arms around each other image" />
        <div class="banner-header standard">
          <div class="content-box">
            <h1 class="c11n-text-lg-headline" [innerHTML]="content.title"></h1>
            <p class="c11n-text-md margin-bottom-2" [innerHTML]="content.description"></p>
            <a c11n-link class="banner-link" iconName="pop-window" [href]="content.link" target="_blank"
            (click)="adobeTrackingForLink()">{{content.linkText}}</a>
          </div>
        </div>
      }

      <ng-template #standard>
        <img class="standard" src="assets/images/advice-banner/Advice-full_width.jpeg"
          alt="back of women with arms around each other image" />
        <img class="mobile" src="assets/images/advice-banner/Advice-mobile.jpg"
          alt="back of women with arms around each other image" />
        <div class="banner-header standard">
          <div class="content-box">
            <h1 class="c11n-text-lg-headline" [innerHTML]="content.title"></h1>
            <p class="c11n-text-md margin-bottom-2" [innerHTML]="content.description"></p>
            <a c11n-link class="banner-link" iconName="pop-window" [href]="content.link" target="_blank"
            (click)="adobeTrackingForLink()">{{content.linkText}}</a>
          </div>

        </div>
      </ng-template>
    </div>

    <div class="content-card c11n-card mobile" [class.rightRail]="rightRail">
      <div class="advice-desc">
        @if (!rightRail) {
          <h1 class="c11n-text-lg-headline margin-bottom-1" [innerHTML]="content.title"></h1>
        }
        <p class="c11n-text-md margin-bottom-2" [innerHTML]="content.description"></p>
        <a c11n-link class="banner-link" iconName="pop-window" [href]="content.link" target="_blank"
        (click)="adobeTrackingForLink()">{{content.linkText}}</a>
      </div>
    </div>
  </div>

</ng-container>
